module.exports = __webpack_public_path__ + "static/img/product_images_02_h5_zh.b87dd65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_02_h5_zh.png
// module id = opaN
// module chunks = 34